<script>
import Jobs from "@/components/jobs/Jobs.vue";
import SearchJob from "@/components/jobs/SearchJob.vue";

export default {
  data() {
    return {
      opportunity: null,
    };
  },
  head() {
    return this.$head({
      title: "Vagas | ",
    });
  },

  components: {
    Jobs,
    SearchJob,
  },
};
</script>

<template>
  <div class="collection">
    <div class="container">
      <h1>sobre a bobô</h1>
      <p>
        Criada em 2006, a Bo.Bô é sinônimo de elegância, glamour e excelência. A marca oferece um guarda-roupa completo que vai do lazer à festa, com peças fabricadas a partir de matérias-primas premium. Com presença constante nos red carpets mais disputados, a Bo.Bô mantém sua essência sofisticada, renovando clássicos de sua história a cada estação – como o animal print, os bordados preciosos, a alfaiataria poderosa, os couros e a clássica sandália Snake, sempre presente em suas coleções.
      </p>
    </div>
  </div>
</template>


<style lang="scss" scoped>
.collection {
    margin-top: 4rem;
}
h1 {
    font-size: 1.9rem;
    text-transform: uppercase;
    font-weight: 500;
    color: #000;
}
p {
    font-size: 1.2rem;
    color: #000;
    margin-top: 1rem;
     border-bottom: 2px solid theme-color(primary);
     padding-bottom: 2rem;
     margin-bottom: 1.5rem;
}
</style>